// extracted by mini-css-extract-plugin
module.exports = {"photoItem":"PhotoItem_photoItem__1X3rk","view":"PhotoItem_view__jT-P5"};